import React from 'react';
import PropTypes from 'prop-types';
import { TableCell } from '@mui/material';
import FlexBox from '../FlexBox';

const ActionsTableCell = ({ children, gap = 0.5, width, sx }) => {
  return (
    <TableCell width={width} sx={sx}>
      <FlexBox justifyContent='end' gap={gap}>
        {children}
      </FlexBox>
    </TableCell>
  );
};

ActionsTableCell.propTypes = {
  children: PropTypes.node,
  gap: PropTypes.number,
  width: PropTypes.string,
  sx: PropTypes.object
};

export default ActionsTableCell;
